export const NAMESPACES = {
  DASHBOARD_ALERTS: "dashboard-alerts",
  DASHBOARD_SET_PASSWORD: "dashboard_alert_text_set_password",
  FRAMES: "frames",
  FACILITIES: "facilities",
  QR_EDITOR_STATS: "qr-editor-stats",
  GENERIC_ERRORS: "generic-errors",
  LAYOUT: "layout",
  STATUS: "status",
  PAGINATION: "pagination",
  TIME_PICKER: "time-picker",
  VALIDATIONS: "validations",
  QR_TYPES: "qr-types",
  ERROR: "error",
  ACCORDION_BLOCKS: "accordion-blocks",
} as const;
